<template>
    <div>
        <div class="flex items-center">
            <h4 v-if="module.remove" class="italic">*Removed</h4>
            <div class="ml-auto">
                <button v-if="module.remove" @click.prevent="module.remove = false" title="Restore">
                    <font-awesome-icon icon="trash-restore" size="sm" class="text-green-500"/>
                </button>
                <button v-else @click.prevent="$emit('remove')" title="Remove">
                    <font-awesome-icon icon="trash" size="sm" class="text-red-600"/>
                </button>
            </div>
        </div>
        <div :class="{'opacity-75': module.remove}">
            <FormGroup
                :name="`modules.${index}.title`"
                label="Title">
                <Input
                    ref="title"
                    v-model="module.title"
                    name="title"
                    placeholder="Please enter the title..."
                    :required="!module.remove"
                    :readonly="module.remove"
                />
            </FormGroup>
        </div>
    </div>
</template>

<script>

import FormGroup from "@/Components/Form/FormGroup.vue";
import Input from "@/Components/Form/Input.vue";

export default {

    props: {
        index: Number,
        module: {
            type: Object,
            required: true,
        }
    },

    components: {
        FormGroup,
        Input
    },

    methods: {
        focus() {
            this.$refs.title.focus();
        }
    },

    watch: {
        module: {
            deep: true,
            handler(module) {
                this.$emit('updated', module);
            }
        }
    },
};

</script>
